<template>
  <div>
    <div class="yo-section" v-if="mode === 'view' || this.mode === 'mark'">
      <h1>Question</h1>
      <Latex ref="latexdisplay" :latex="question.latex" />
    </div>
    <div class="yo-section" v-if="question.ansType !== 'unknown'">
      <div class="yo-content-block" v-if="question.ansType === 'many-ans-mc'">
        <h2 v-if="mode === 'view'">
          Multiple Answer MC
        </h2>
        <RespMaMC @view="onView" @saveTo="saveTo" @submit="onSubmit" :question="question" :answer="answer" :mode="mode"></RespMaMC>
      </div>
      <div class="yo-content-block" v-if="question.ansType === 'one-ans-mc'">
        <h2 v-if="mode === 'view'">
          Single Answer MC
        </h2>
        <RespSaMC @view="onView" @saveTo="saveTo" @submit="onSubmit" :question="question" :answer="answer" :mode="mode"></RespSaMC>
      </div>
      <div class="yo-content-block" v-if="question.ansType === 'text-ans'">
        <h2 v-if="mode === 'view'">
          Text Answer
        </h2>
        <RespText @view="onView" @saveTo="saveTo" @submit="onSubmit" :question="question" :answer="answer" :mode="mode"></RespText>
      </div>
      <div class="yo-content-block" v-if="question.ansType === 'math-eq-ans'">
        <h2 v-if="mode === 'view'">
          Math Equation Doodle
        </h2>
        <RespMathDoodle @view="onView" @saveTo="saveTo" @submit="onSubmit" :question="question" :answer="answer" :mode="mode"></RespMathDoodle>
      </div>
      <div class="yo-content-block" v-if="question.ansType === 'range-val-ans'">
        <h2 v-if="mode === 'view'">
          Ranged Value Answer
        </h2>
        <RespRangedValue @view="onView" @saveTo="saveTo" @submit="onSubmit" :question="question" :answer="answer" :mode="mode"></RespRangedValue>
      </div>
      <div class="yo-content-block" v-if="question.ansType === 'open-end-ans'">
        <h2 v-if="mode === 'view'">
          Open Ended Question / Survey
        </h2>
        <RespOpenEnd @view="onView" @saveTo="saveTo" @submit="onSubmit" :question="question" :answer="answer" :mode="mode"></RespOpenEnd>
      </div>
      <div style="display: none;">{{ question }}</div>
      <!-- <Latex ref="latexdisplay" :placeholder="' '" :latex="question.latex" /> -->
    </div>
  </div>
</template>

<script>
export default {
  components: {
    Latex: require('../editor-parts/Latex.vue').default,
    RespMathDoodle: require('../editor-parts/RespMathDoodle.vue').default,
    RespOpenEnd: require('../editor-parts/RespOpenEnd.vue').default,
    RespRangedValue: require('../editor-parts/RespRangedValue.vue').default,
    RespText: require('../editor-parts/RespText.vue').default,
    RespMaMC: require('../editor-parts/RespMaMC.vue').default,
    RespSaMC: require('../editor-parts/RespSaMC.vue').default
  },
  props: {
    answer: {},
    mode: {
      default: 'view'
    },
    question: {}
  },
  methods: {
    saveTo (v) {
      this.$emit('saveTo', v)
    },
    onView (v) {
      this.$emit('view', v)
    },
    onSubmit(v) {
      this.$emit('submit', v)
    }
  }
}
</script>

<style>

</style>
